import LiftRAndRLogo from '@/assets/branding/liftrandr/lift-r-and-r-logo.png';

const colors = {
  // Brand colors
  brand_primary: '#EB6D29', // H21°, L54, S83
  brand_primary_hover: '#C4571C', // −10 L, −8 S
  brand_primary_highlight: '#F9B590', // +23 L, +7 S
  brand_primary_mid: '#F0854C', // +8 L,  +2 S
  brand_primary_dark: '#85380F', // −25 L, −3 S
  brand_secondary: '#A9581E', // hue +4°, −15 L, −13 S
  brand_accent_start: '#F17F3D',
  brand_accent_end: '#E9B531',
  brand_accent_light_start: '#FFF2EA',
  brand_accent_light_end: '#FFF2D8',
  brand_complementary_accent: 'rgb(58,174,237)',
  brand_auth_gradient_mid: '#A9581E',
  brand_auth_gradient_end: '#85380F',
  brand_auth_warp_mid: '#F0854C',
};

export default {
  name: 'Lift R & R',
  isSAML: true,
  allowPersonalCourses: false,
  logo: LiftRAndRLogo,
  colors,
};
